import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import EmailIcon from 'mdi-react/EmailIcon';
import PhoneIcon from 'mdi-react/PhoneIcon';
import './stylevn.css';

import langData from "../../../translations/translations.json"

function FooterEn({ lang = 'en' }) {
    // const content = langData[lang].footer;
    const content = langData.footer;

    const langContent = {
        addresses: content.addresses[lang],
        email: content.email[lang],
        phoneLabel: content.phoneLabel[lang],
        phoneNumber: content.phoneNumber[lang],
        copyright: content.copyright[lang]
    };

    return (
        <div id="footer-wp">
            <div className="footer-top-wrap">
                <div className="fit-width footer-body-wrap container">
                    <div className="row">
                        <div className="logo-footer">
                            <div className="MuiBox-root css-0">
                                <div className="logo-footer-detail-wrap MuiBox-root css-0">
                                    <img
                                        className="logo-footer-img-wrap"
                                        src="https://hanbiro.com/cloud/library/cloudconsult/logo-footer.svg"
                                        alt="logo"
                                    />

                                    <div
                                        className="typo-mess"
                                        dangerouslySetInnerHTML={{ __html: langContent.addresses }}
                                    />

                                    <p className="typo-mess">
                                        <EmailIcon className="icon-text-wp" />
                                        <a href={`mailto:${langContent.email}`} className="text-color-wp">
                                            {langContent.email}
                                        </a>
                                        &nbsp;&nbsp;&nbsp;
                                        <PhoneIcon className="icon-text-wp" />
                                        {langContent.phoneLabel}{' '}
                                        <a href={`tel:${langContent.phoneNumber}`} className="text-color-wp">
                                            {langContent.phoneNumber}
                                        </a>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <hr className='divi-footer' />
            <div>
                <div className="footer-bottom-wp">
                    <div className="fit-width">
                        <p>{langContent.copyright}</p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default FooterEn;
